import { TransformError } from 'components/Form/Form.types';

export const errorMessageMinPrefix = 'error.minLength';

export const errorMessageMaxPrefix = 'error.maxLength';

export const transformLengthError: TransformError =
  function transformNumberRangeError(error) {
    const output = { i18nKey: error } as ReturnType<TransformError>;

    if (
      error.startsWith(errorMessageMinPrefix) ||
      error.startsWith(errorMessageMaxPrefix)
    ) {
      const offset = error.lastIndexOf('.');

      output.i18nKey = error.slice(0, offset);
      output.values = { value: error.slice(offset + 1) };
    }

    return output;
  };
